import { Container } from '@mantine/core';

export default function PrivacyPolicy() {
  return (
    <Container size="sm" pt="md" pb="xl">
      <iframe
        src="/privacy-policy.html"
        style={{
          width: '100%',
          minHeight: '80vh',
          border: 'none',
        }}
        title="Privacy Policy"
      />
    </Container>
  );
}
